module.exports = __webpack_public_path__ + "static/media/tax-breakdown-table-column.e1560f84.png";